// src/components/ThemeFilters.jsx
import React from 'react';

const ThemeFilters = ({
  activeFilters,
  setActiveFilters,
  themeFilters,
  isDarkMode
}) => {
  const handleThemeToggle = (type) => {
    setActiveFilters(prev => {
      const isAllActive = prev.theme.length === themeFilters.length;
      
      if (isAllActive) {
        return {
          ...prev,
          theme: [type]
        };
      }
      
      return {
        ...prev,
        theme: prev.theme.includes(type)
          ? prev.theme.filter(t => t !== type)
          : [...prev.theme, type]
      };
    });
  };

  return (
    <div className="flex flex-wrap gap-2">
      {themeFilters.map(({ type, Icon, color }) => (
        <button
          key={type}
          onClick={() => handleThemeToggle(type)}
          className={`
            relative h-10 px-4 rounded-lg text-sm font-medium transition-all flex items-center gap-2 overflow-hidden
            ${isDarkMode 
              ? 'bg-[#383838] text-gray-300 hover:bg-[#484848]'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }
            ${activeFilters.theme.includes(type) &&
              'before:content-[""] before:absolute before:left-0 before:top-0 before:bottom-0 before:w-1 before:bg-[#e8c2d9]'
            }
          `}
        >
          <Icon size={18} />
          {type}
        </button>
      ))}
    </div>
  );
};
export default ThemeFilters;